import { render, staticRenderFns } from "./UplimitStep.vue?vue&type=template&id=b04fc410&scoped=true"
import script from "./UplimitStep.vue?vue&type=script&lang=js"
export * from "./UplimitStep.vue?vue&type=script&lang=js"
import style0 from "./UplimitStep.vue?vue&type=style&index=0&id=b04fc410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04fc410",
  null
  
)

export default component.exports